import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { KTCard, KTCardBody, Loader, enumPolicies } from '../../../../_metronic/helpers'
import { PRIMARY_COLOR } from '../../../../_metronic/helpers/colorConstant';
import Swal from 'sweetalert2'
import PolicyChecker from '../../../../_metronic/helpers/components/PolicyChecker';

import { clearState, getProductList, changeStatus, cloneProduct, getCategories } from './productActions';
import ProductListTable from './components/ProductListTable';

const Products = (props) => {
    //inputs from url
    const params = useParams();
    const intl = useIntl()
    
    //inputs from redux
    const {
        productList,
        loading,
        success,
        categories
    } = props;

    //actions
    const {
        clearState,
        getProductList,
        changeStatus,
        cloneProduct,
        getCategories
    } = props;


    const [keyword, setKeyword] = useState("");
    const [categoryId, setCategoryId] = useState(null);
    const [sorting, setSorting] = useState({ name: "", sku: "" })
    const [sortedList, setSortedList] = useState([]);

    useEffect(() => {
        getCategories();
        return () => {
            clearState()
        }
    }, []);

    useEffect(() => {
        setTimeout(() => { 
            MenuComponent.reinitialization();
        }, 100)
        setSortedList(productList || []);
    }, [productList])

    useEffect(() => {
        if (success) {
            toast.success(intl.formatMessage({ id: success }));
        }
    }, [success])


    useEffect(() => {
        if (keyword != undefined || categoryId !== null) {
            const timeOutId = setTimeout(() => getProductList(keyword, categoryId), 400);
            return () => clearTimeout(timeOutId);
        }
    }, [keyword, categoryId]);

    const breadcrumbs = [
        {
            title: intl.formatMessage({ id: 'CATALOG.MANAGEMENT.TITLE' }),
            path: '/catalog-management/products',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,        }
    ]

    const onSearch = (value) => {
        setKeyword(value);
    }

    const onCategoryChange = (e) => {
        setCategoryId(e.target.value === "" ? null : e.target.value);
    }

    const onStatusChange = (id, isActive) => {
        changeStatus(id, isActive);
    }

    const onClone = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to clone of this product?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: PRIMARY_COLOR,
            cancelButtonColor: "#dbdfe9",
            confirmButtonText: "Yes"
        }).then((result) => {
            if (result.isConfirmed) {
                cloneProduct(id)
            }
        });
    }

    const onChangeSorting = (field) => {
        let list = [...sortedList];
        if (field === "name") {
            const sort = sorting["name"];
            if (sort === "table-sort-asc") {
                list.sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });
                setSorting({ name: "table-sort-desc", sku: "" })
            } else {
                list.sort((a, b) => {
                    if (a.name > b.name) return -1;
                    if (a.name < b.name) return 1;
                    return 0;
                });
                setSorting({ name: "table-sort-asc", sku: "" })
            }
        } else if (field === "sku") {
            const sort = sorting["sku"];
            if (sort === "table-sort-asc") {
                list.sort((a, b) => (a.sku || "").localeCompare(b.sku || ""));
                setSorting({ sku: "table-sort-desc", name: "" })
            } else {
                list.sort((a, b) => (b.sku || "").localeCompare(a.sku || ""));
                setSorting({ sku: "table-sort-asc", name: "" })
            }
        }
        setSortedList(list);
    }

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs} >{intl.formatMessage({ id: 'PRODUCT.LIST.BREADCRUMB' })}</PageTitle>

            <KTCard>

                <div className="card-header border-0 pt-6">
                    <div className="card-title">
                        <div className="d-flex align-items-center position-relative my-1">
                            <i className="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                            <input type="text" data-kt-user-table-filter="search" className="form-control form-control-solid w-250px ps-14" placeholder={intl.formatMessage({ id: 'PRODUCT.LIST.SEARCH.PRODUCT' })} value={keyword} onChange={(e) => onSearch(e.target.value)} />
                        </div>
                        <div className="w-100 mw-200px ms-5">
                            <select className="form-select form-select-solid" onChange={onCategoryChange} value={categoryId || ''}>
                                <option value="">{intl.formatMessage({ id: 'PRODUCT.SELECT.CATEGORY' })}</option>
                                {categories && categories.map((c) => (
                                    <option key={c.id} value={c.id}>{c.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="card-toolbar">
                        <div className="d-flex justify-content-end gap-5" data-kt-user-table-toolbar="base">
                            <PolicyChecker policies={[enumPolicies.ProductWrite]}>
                                <Link to={`/catalog-management/products/0`} type="button" className="btn btn-success text-nowrap"><i className="ki-duotone ki-plus fs-2"></i>{intl.formatMessage({ id: 'PRODUCT.LIST.ADD.PRODUCT' })}</Link>
                            </PolicyChecker>
                        </div>
                    </div>

                </div>
                <KTCardBody className='table-responsive m-grid-responsive-md'>

                    <ProductListTable 
                        data={sortedList} 
                        intl={intl} 
                        sorting={sorting} 
                        onChangeSorting={onChangeSorting} 
                        onStatusChange={onStatusChange}
                        onClone={onClone}
                    />

                </KTCardBody>
            </KTCard >
            {loading && <Loader></Loader>}
        </>
    );
};

const mapStateToProps = state => {
    return {
        productList: state.Product.productList,
        loading: state.Product.loading,
        success: state.Product.success,
        categories: state.Product.categories
    };
};

const mapActionsToProps = {
    clearState, getProductList, changeStatus, cloneProduct, getCategories
}

export default connect(mapStateToProps, mapActionsToProps)(Products)
